import classNames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'

import { ButtonRoundSm } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { CARD_RADIUS_STYLES } from '@apps-common/config/styles'
import { ICidEventModel } from '@apps-common/types/cid-event-code'

interface IProps {
  event: ICidEventModel
  callback: (event: ICidEventModel) => void
}

export const CidEventCard: React.FC<IProps> = ({ event, callback }) => {
  const { code, description } = event

  return (
    <AnimatePresence>
      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        type='button'
        className={classNames(CARD_RADIUS_STYLES, 'p-[1.5rem] bg-surface text-text border border-border')}
        onClick={() => callback(event)}
      >
        <div className='relative text-left flex items-center justify-start gap-[20px]'>
          <p className='text-[0.9em] jost-light'>
            <span className='jost text-[0.9em]'>Code</span>
            <br />
            {code}
          </p>
          <p className='text-[0.9em] jost-light grow border-l border-border pl-[20px]'>
            <span className='jost text-[0.9em]'>Description</span>
            <br />
            {description}
          </p>
          <ButtonRoundSm type='div' className='bg-brand text-on-brand'>
            <commonIcons.arrowAngled />
          </ButtonRoundSm>
        </div>
      </motion.button>
    </AnimatePresence>
  )
}
